export default __webpack_public_path__ + "static/Dr-saba-jamal-92b6399f1e80d1e425cc1bbb272f9667.jpg";